import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  CdkDropList,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import { BookManagementService } from '../book-management.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NgxLoadingModule } from 'ngx-loading';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-bm-launch-modal',
  templateUrl: './bm-launch-modal.component.html',
  styleUrls: ['./bm-launch-modal.component.scss'],
  imports: [
    NgxLoadingModule,
    MatIconModule,
    CdkDropList,
    MatTooltipModule,
    MatButtonModule,
  ],
})
export class BmLaunchModalComponent implements OnInit {
  private dialogRef =
    inject<MatDialogRef<BmLaunchModalComponent>>(MatDialogRef);
  private bmSvc = inject(BookManagementService);
  private route = inject(Router);
  private snacky = inject(MatSnackBar);
  data = inject(MAT_DIALOG_DATA);

  selected = [];
  exchange = [];
  deposit = [];
  loading = false;

  ngOnInit() {
    this.selected = this.data.selectedAnnuities;
  }

  drop(event) {
    if (
      event.previousContainer === event.container ||
      (event.container.element.nativeElement.classList.contains(
        'deposit-list'
      ) &&
        event.container.data.length >= 1)
    ) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  saveData() {
    this.loading = true;
    let exchangeChecked = false;
    let depositChecked = false;
    const processedExchange = [];
    const processedDeposit = [];

    if (this.exchange.length > 0) {
      this.exchange.map((policy, index) => {
        this.bmSvc.getPolicy(policy.ID, 'ConvertToCADA').subscribe({
          next: resp => {
            processedExchange.push(resp['CurrentAnnuityDetailsArray'][0]);
            if (index === this.exchange.length - 1) {
              exchangeChecked = true;
            }

            if (
              exchangeChecked &&
              depositChecked &&
              index === this.exchange.length - 1
            ) {
              setTimeout(() => {
                this.processSaveData(processedExchange, processedDeposit);
              }, 2500);
            }
          },
          error: err => {
            this.throwError(err);
          },
        });
      });
    } else {
      exchangeChecked = true;
    }

    if (this.deposit.length > 0) {
      this.deposit.map((policy, index) => {
        depositChecked = true;
        this.bmSvc
          .getPolicy(policy.ID, 'ConvertToAdditionalDepositAnnuity')
          .subscribe({
            next: resp => {
              processedDeposit.push(resp['AdditionalDepositAnnuity']);
              if (index === this.deposit.length - 1) {
                depositChecked = true;
              }

              if (
                exchangeChecked &&
                depositChecked &&
                index === this.deposit.length - 1
              ) {
                setTimeout(() => {
                  this.processSaveData(processedExchange, processedDeposit);
                }, 2500);
              }
            },
            error: err => {
              this.throwError(err);
            },
          });
      });
    } else {
      depositChecked = true;
    }
  }

  processSaveData(exchangeArray, depositArray) {
    const profileJson = {
      CurrentAnnuityDetailsArray: [...exchangeArray, ...depositArray],
    };
    if (exchangeArray.length > 0) {
      profileJson['CurrentAnnuityDetailsArray'] = exchangeArray;
    }
    if (depositArray.length > 0) {
      profileJson['AdditionalDepositAnnuity'] = depositArray[0];
    }
    this.bmSvc.launchAwProfile(profileJson).subscribe({
      next: resp => {
        this.loading = false;
        this.selected = [];
        this.exchange = [];
        this.deposit = [];
        this.dialogRef.close({ data: 'cancel' });
        this.route.navigate([
          `case/${this.data.launchLocation.toLowerCase()}/${resp['results']}/0`,
        ]);
      },
      error: err => {
        this.throwError(err);
      },
    });
  }

  close() {
    this.selected = [];
    this.exchange = [];
    this.deposit = [];
    this.dialogRef.close({ data: 'cancel' });
  }

  throwError(err) {
    this.loading = false;
    this.dialogRef.close({ data: 'cancel' });
    this.snacky.open(
      'Sorry, an error occurred and we are unable to complete this action'
    );
    console.warn(err);
  }

  removeAnnuity(item, listType) {
    const index = this[listType].findIndex(policy => policy.ID === item.ID);
    this[listType].splice(index, 1);
  }
}
